import { inject, Injectable } from '@angular/core';
import { LoggerService } from '@pf/shared-services';
import { TypeEntityTypes } from '@pf/shared-common';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';
import { ResolutionTypesService } from '@control-tower/platform-wms';

@Injectable()
export class ResolutionTypeFacade extends AbstractTypeEntityFacade<ResolutionTypesService> {
    constructor() {
        const typeService = inject(ResolutionTypesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            typeService,
            'resolutionTypeGetAll',
            TypeEntityTypes.ResolutionType
        );
    }
}
